import { ApiNetworkError } from "@/errors/api/api-network-error";

/**
 * API無電波エラー
 */
export class ApiNoNetworkError extends ApiNetworkError {
  /**
   * コンストラクタ
   */
  constructor(message: string) {
    super(message);
  }
}
